"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStatusPageConfig = void 0;
const modules_1 = require("../modules");
const defaultStatusPageConfig = (image) => {
    return new modules_1.PageModule({
        id: "status_page",
        modules: [
            new modules_1.ContainerModule({
                id: "status_page_container",
                style: { width: "100%", maxWidth: "660px", marginBottom: 30 },
                modules: [
                    new modules_1.CardModule({
                        id: "status_page_card",
                        image: { align: "center", src: image },
                        variant: "header",
                        backgroundColor: "#FAFBFB",
                        modules: [
                            new modules_1.ContainerModule({ modules: [], style: { height: 14 } }),
                            new modules_1.TextModule({
                                id: "status_page_body",
                                label: {
                                    en: "Thank you for visiting this survey. Unfortunately, we are no longer collecting entries.",
                                },
                                variants: { desktop: "Body1", mobile: "Body1" },
                            }),
                        ],
                    }),
                ],
            }),
        ],
    }).toSurveyConfig();
};
exports.defaultStatusPageConfig = defaultStatusPageConfig;
//# sourceMappingURL=statusPage.js.map